import svgUrl from "ni:svgr;KJpLM2xURVEvcY-ExHBbvz6mQZE3JS5DWxpB-LqSb_0";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const LocalFileLIcon = props => <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" fillOpacity={0.4} clipRule="evenodd" d="M9 3a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V9l-6-6h2.008H9Z" fill="var(--tbl--colors--icons--transformation--primary)" /><path d="M21 7V3l6 6h-4a2 2 0 0 1-2-2Z" fill="#fff" fillOpacity={0.5} /></svg>;
const Memo = memo(LocalFileLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "LocalFileLIcon";
}